<template>
    <div class="w-full bg-a-blue-002850" data-cy="container_topbar_back">
        <img class="pt-4" data-cy="btn_topbar_back" :src="icBackUrl()" @click="onClickBack()" />
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ConfigManager from "@/config/ConfigManager.js";
export default {
    name: "TopBarBack",
    mixins: [LocaleMixin],
    data: function() {
        return {};
    },
    methods: {
        onClickBack: function(){
            this.$emit('onClickBack');
        },
        icBackUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/img-back.png`;
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
